import { paramsToQuery } from '@/base/MaUtils.js'
import { cacheRequest } from '@/base/MaRequestPooler.js'

export function getCategoryRatings({ trackId, country }) {
  return cacheRequest(`/app/${trackId}/rating/category?${paramsToQuery({ country })}`)
}

export function getTotalRatings({ trackId, country }) {
  return cacheRequest(`/app/${trackId}/rating/total?${paramsToQuery({ country })}`)
}

export function getIncrementalRatings({ trackId, country, startDate, endDate }) {
  return cacheRequest(`/app/${trackId}/rating/incremental?${paramsToQuery({ country, startDate, endDate })}`)
}

export function getTotalCountryRatings({ trackId }) {
  return cacheRequest(`/app/${trackId}/rating/total/country`)
}

export function getIncrementalCountryRatings({ trackId, startDate, endDate }) {
  return cacheRequest(`/app/${trackId}/rating/incremental/country?${paramsToQuery({ startDate, endDate })}`)
}

export function getTotalVersionRatings({ trackId, country }) {
  return cacheRequest(`/app/${trackId}/rating/total/version?${paramsToQuery({ country })}`)
}

export function getIncrementalVersionRatings({ trackId, startDate, endDate, country }) {
  return cacheRequest(`/app/${trackId}/rating/incremental/version?${paramsToQuery({ startDate, endDate, country })}`)
}

export function getChartTotalRatings({ trackId, country, type }) {
  return cacheRequest(`/app/${trackId}/rating/chart/total?${paramsToQuery({ country, type })}`)
}

export function getChartIncrementalRatings({ trackId, country, type, startDate, endDate }) {
  return cacheRequest(`/app/${trackId}/rating/chart/incremental?${paramsToQuery({ country, type, startDate, endDate })}`)
}
